import { useContext, useEffect } from "react";

import ParamsContext from "context/params/paramsContext";
import TableContext from "context/table/tableContext";
import { isRefreshableTaskType } from "shared/functions";
import { useApi } from "shared/hooks/useApi";
import { useIsMounted } from "shared/hooks/useIsMounted";
import { TABLE_NAMES } from "shared/types/enums";
import { BatchTaskStatus } from "shared/types/interfaces";

import { useGetSingleTaskGroupEndpoint } from "./useGetSingleTaskGroupEndpoint";

export const useTaskGroupUpdate = (
    id: number,
    taskStats: BatchTaskStatus[],
    isSelected: boolean
) => {
    const { setReloadItems } = useContext(ParamsContext);
    const { updateSingleRowData } = useContext(TableContext);

    const { getSingleTaskGroupEndpoint } = useGetSingleTaskGroupEndpoint();
    const { getData, isCanceled, handleResponse } = useApi();
    const isMounted = useIsMounted();

    const getRequestStatus = () => {
        const isAtLeastOneRefreshable = taskStats.some(
            ({ status_id }: BatchTaskStatus) => isRefreshableTaskType(status_id)
        );

        return isSelected && isAtLeastOneRefreshable;
    };

    const isReadyToRequest = getRequestStatus();

    useEffect(() => {
        const getBatchData = async (shoudTasksReload: boolean) => {
            try {
                const { data: batchData } = await getData(
                    getSingleTaskGroupEndpoint(id)
                );

                if (isMounted) {
                    updateSingleRowData(batchData);
                    shoudTasksReload && setReloadItems(TABLE_NAMES.Tasks, true);
                }
            } catch (error) {
                if (isMounted && !isCanceled(error)) {
                    handleResponse(error);
                }
            }
        };

        isReadyToRequest && getBatchData(false);

        const timer = setInterval(() => {
            isReadyToRequest && getBatchData(true);
        }, 60000);

        return () => clearInterval(timer);
        // eslint-disable-next-line
    }, [isReadyToRequest]);
};
